import axios from 'axios';

const bankVerificationAxiosInstance = axios.create({
  baseURL: 'https://kyc-api.surepass.io',
  timeout: 30000,
});

bankVerificationAxiosInstance.interceptors.request.use((config) => {
  const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcyNTM1OTgyMywianRpIjoiZGVmZTJlYzgtNjgwMC00N2YyLWFjNmQtYTAyM2Y5MTBlZTllIiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2Lm1vdGhlcnNvbl9jb25zb2xlQHN1cmVwYXNzLmlvIiwibmJmIjoxNzI1MzU5ODIzLCJleHAiOjIwNDA3MTk4MjMsImVtYWlsIjoibW90aGVyc29uX2NvbnNvbGVAc3VyZXBhc3MuaW8iLCJ0ZW5hbnRfaWQiOiJtYWluIiwidXNlcl9jbGFpbXMiOnsic2NvcGVzIjpbInVzZXIiXX19.sWCUNlIaD9ca4sEBTWgZ9FoeEIPesKs_kyC_kqLeE48'; // Replace with your token retrieval logic
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default {
  install: (app) => {
    app.config.globalProperties.$bank_verification_axios = bankVerificationAxiosInstance ;
    app.provide('bank_verification_axios', bankVerificationAxiosInstance );
  },
};
export { bankVerificationAxiosInstance };
